<button mat-icon-button aria-label="remove balance"
    (click)="openModalForNonProgrammable(element)">
    <mat-icon color="warn"> delete </mat-icon>
</button>